import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { IContactCategoryData } from 'src/app/common/models/IContactCategoryData';
import { IContactData } from 'src/app/common/models/IContactData';
import { IRecordsUpdate } from 'src/app/common/models/IRecordsUpdate';
import { ITagData } from 'src/app/common/models/ITagData';
import { ClearUpdateData, SetContactCategoryUpdateData, SetContactUpdateData,
   SetRecordsUpdateData, SetTagUpdateData } from './update-settings.actions';


export class UpdateSettingsStateModel {
  recordsData: IRecordsUpdate;
  contactData: IContactData;
  contactCategoryData: IContactCategoryData;
  tagData: ITagData;
}

@State<UpdateSettingsStateModel>({
    name: 'updateSettings',
    defaults: {
      recordsData: null,
      contactData: null,
      contactCategoryData: null,
      tagData: null
    }
})

@Injectable()
export class UpdateSettingsState {

    @Selector()
    static getUpdateDataState(state: UpdateSettingsStateModel) {
        return state;
    }

    @Action(SetRecordsUpdateData)
    public setRecordsOf({ getState, setState }: StateContext<UpdateSettingsStateModel>,
       { recordsData }: SetRecordsUpdateData) {
        const state = getState();
        setState({ ...state, recordsData });
    }

    @Selector()
    static getContactUpdateDataState(state: UpdateSettingsStateModel) {
        return state.contactData;
    }

    @Action(SetContactUpdateData)
    public setContactData({ getState, setState }: StateContext<UpdateSettingsStateModel>,
       { contactData }: SetContactUpdateData) {
        const state = getState();
        setState({ ...state, contactData });
    }

    @Selector()
    static getContactCategoryUpdateDataState(state: UpdateSettingsStateModel) {
        return state.contactCategoryData;
    }

    @Action(SetContactCategoryUpdateData)
    public setContactCategoryUpdateData({ getState, setState }: StateContext<UpdateSettingsStateModel>,
       { contactCategoryData }: SetContactCategoryUpdateData) {
        const state = getState();
        setState({ ...state, contactCategoryData });
    }

    @Selector()
    static getTagUpdateDataState(state: UpdateSettingsStateModel) {
        return state.tagData;
    }

    @Action(SetTagUpdateData)
    public setTagUpdateData({ getState, setState }: StateContext<UpdateSettingsStateModel>,
       { tagData }: SetTagUpdateData) {
        const state = getState();
        setState({ ...state, tagData });
    }

    @Action(ClearUpdateData)
    public clearRecordsOf({ getState, setState }: StateContext<UpdateSettingsStateModel>) {
        const state = getState();
        setState({ ...state, recordsData: null, contactData: null, contactCategoryData: null, tagData: null });
    }
}
